import assign                   from 'lodash.assign';
import eventEmitter             from 'shared/mixins/eventEmitter';
import {createBrowserHistory,createHashHistory} from 'history'
import faqForm                  from './form';
import faqResult                from './result';
import askQuestion              from '../../elements/ask-question/ask-question';
import Hogan                    from 'hogan.js';

const paramSplitter             = /([^=?&]+)=([^&]*)/g;

/**
 * FAQ
 * this module works as a wrapper around the faq
 * components.
 */
faq.selector = '[data-js-faq]';
function faq(el, app) {
    
    const $el                   = $(el);
    const baseUrl               = $el.data('js-faq-host');
    const defaultCount          = $el.data('js-faq-default-count') || 7;
    const $spinner              = $el.find('[data-js-faq-spinner]');
    const $clearSearch          = $el.find('[data-js-faq-ask-clear]');
    const events                = eventEmitter();
    const supportsPushState     = !!window.history.pushState;
    const history               = supportsPushState ? createBrowserHistory() : createHashHistory();
    const params                = {};

    const tmplCategory          = Hogan.compile($('#faq-tmpl-category').html(), {delimiters: '[% %]'});
    const tmplPrivateContact    = Hogan.compile($('#faq-tmpl-contact-private').html(), {delimiters: '[% %]'});
    const tmplCompanyContact    = Hogan.compile($('#faq-tmpl-contact-company').html(), {delimiters: '[% %]'});
    const tmplAnswer            = Hogan.compile($('#faq-tmpl-answer').html(), {delimiters: '[% %]'});
    const tmplFeedback          = Hogan.compile($('#faq-tmpl-feedback').html(), {delimiters: '[% %]'});
    const tmplQuestion          = Hogan.compile($('#faq-tmpl-question').html(), {delimiters: '[% %]'});

    let categoriesLoaded        = false;
    let singleMode              = false;
    let timerLogSearch          = null;

    /**
     * init
     * initializes the module and its child
     * modules.
     */
    const init = function() {
        history.listen(parseParams);

        let question = $el.data('js-faq-question');
        let category = $el.data('js-faq-category');
        createChilds();

        parseParams(history.location);

        if (question) {
            singleMode = true;
            $
                .when(scrollIntoView())
                .then(() => fetchCategories(false))
                .then(() => fetchQuestion(question))
        }

        else { executeSearch(true); }

        // when clear search was clicked, just
        // remove all the params.
        $clearSearch.click((evt) => {
            evt.preventDefault();
            // NOTE: This is slightly naughty, reaching into the DOM of another _sub_ module (the form),
            // probably triggering an event in "events" here would be more "correct". But
            // going for the quickest solution atm.
            $el.find('[data-js-faq-search]').val('');

            setParams({
                query: undefined,
                commonSearch: undefined,
                category: undefined,
                question: undefined
            });

            app.trigger('beacon','faq-search-clear');
        });

        events.on('param', paramsChanged);
    };

    /**
     * Makes a call to the api to fetch all the
     * categories that you can filter on.
     *
     * @param {Boolean} includeQuestions decided whether to include the top popular questions into the result.
     */
    const fetchCategories = function(includeQuestions){
        let query = {
            command: 'Qa-GetCategories'
        };

        if (includeQuestions) {
            query.includeQuestions = '1';
            query.maxCount = defaultCount;
        }

        fetchFromApi(query, { gaFailLabel: 'categories-fail' })
            .then((data) => {

                if (!categoriesLoaded) {
                    events.trigger('categories', data.result.categories);
                    categoriesLoaded = true;
                }
                // store the categories for later look-up
                if (!app.faq) {app.faq = {}}; 
                app.faq.categories = data.result.categories;

                // if no search is available in the url,
                // use the category questions as result.
                if (!params.query && !params.category && !params.question) {
                    events.trigger('result', data.result);
                }
            });
    }

    const fetchSearchResult = function(onPageLoad) {
        // fetch new result.
        let query = { command: 'Qa-GetQuestions' };
        if (params.category) { query.categories = params.category; }
        if (params.query) { query.searchFor = params.query; }

        fetchFromApi(query, { gaFailLabel: 'search-fail' })
            .then((data) => {
                events.trigger('result', {
                    categories: [{ questions: data.result.questions }]
                });
                
                // beacon ga (only on user action, not on page load)
                if (!onPageLoad) {
                    const resultLength = ( data.result && data.result.questions ? data.result.questions.length : 0 );
                    // category
                    if (params.category) { 
                        // find category name
                        let   cat = 'unknown';
                        const catLookupArray = app.faq.categories;
                        catLookupArray.forEach((val) => {
                            if (val.id + '' === params.category + '') {
                                cat = val.name;
                            }
                        });
                        app.trigger('beacon','faq-search-category,' + ( cat && cat.length ? cat.replace(',',' ').toLowerCase() : 'unknown category' ) + ',' + resultLength);
                    // common search link
                    } else if (params.commonSearch) { 
                        app.trigger('beacon','faq-search-common,' + (params.query + '').trim().toLowerCase().replace(',',' ') + ',' + resultLength);
                    // searchbox
                    } else {
                        // try to debounce search results
                        clearTimeout(timerLogSearch);
                        timerLogSearch = setTimeout(() => {
                            app.trigger('beacon','faq-search-keyword,' + (params.query + '').trim().toLowerCase().replace(',',' ') + ',' + resultLength);
                        },2000);
                    }
                }
            });
    };

    /**
     * loads one question
     */
    const fetchQuestion = function(id) {
        let query = {
            command: 'Qa-GetQuestion',
            question: id
        };

        fetchFromApi(query, { gaFailLabel: 'single-question-fail' })
            .then((data) => {
                events.trigger('single', data.result.question);

                // ga
                app.trigger('beacon','faq-question-result,question,' + id);
            });
    };

    /**
     * This is a general fetch function that loads
     * data from the api.
     */
    const fetchFromApi = function(data, options) {
        let url = `${document.location.protocol}//${baseUrl}/GeneralApi`;

        $el.toggleClass('Ge-Faq--Loading', true);
        $spinner.attr('aria-hidden', 'false');

        return $
            .ajax(url, { data })
            .then((data) => {
                $el.toggleClass('Ge-Faq--Loading', false);
                $spinner.attr('aria-hidden', 'true');

                if (data.status !== 'Ok') {
                    let error = data.result.message;
                    throw new Error(error);
                }

                return data;
            })
            .fail((err) => {
                let gaFailLabel = options && options.gaFailLabel ? options.geFailLabel : 'generic';
                app.trigger('beacon',`faq-question-error-${gaFailLabel},${err}`);
                fetchFailed(err);
            });
    };

    /**
     * fetch failed
     */
    const fetchFailed = function(err) {
        const errorMsg = (dictionaryFaqResults ? dictionaryFaqResults.generalError : '' );
        app.trigger('msgGlobal',[errorMsg,'faqError','error',true,false]);
        $spinner.attr('aria-hidden', 'true');
    };

    /**
     * Event handler for when the parameters has
     * changed.
     */
    const paramsChanged = function(changedParams) {
        var changedKeys = Object.keys(changedParams);

        if (!singleMode && (changedKeys.indexOf('category') === -1 && changedKeys.indexOf('query') === -1)) {
            return;
        }

        executeSearch();
    };

    /**
     * executes a search with the current param settings
     */
    const executeSearch = function(onPageLoad) {

        app.trigger('msgGlobalKill',['faqError']);

        // start by triggering the event that we are searching..
        let promise = $.when($.Deferred((defer) => {
            events.trigger('searching');
            setTimeout(defer.resolve, 300);
        }));

        // if we have a search (not just an initial page load, we
        // should also scroll...
        if (params.query || params.category) {
            promise = promise.then(() => scrollIntoView())
        }

            /// ... then run the query or queries.
        return promise.then(() => {
            singleMode = false;
            let operations = [];

            // if we had query or category
            // we should make a search...
            if (params.query || params.category) {
                operations.push(fetchSearchResult(onPageLoad));
                if (!categoriesLoaded) {
                    operations.push(fetchCategories(false,onPageLoad));
                }
            }

            else {
                // otherwise return to the initial state by
                // fetching the categories and their top answers
                operations.push(fetchCategories(true,onPageLoad));
            }

            return $.when.apply($, operations);
        });
    };

    /**
     * returns a promise that is resolved when the screen has scrolled
     * to the position where the search is in view
     */
    const scrollIntoView = function() {
        let scrollTarget = 0;
        let scrollEl;

        // if we have a query, the scroll target should be the form.
        if (singleMode) { scrollEl = $el.find('[data-js-faq-result]'); }
        else if (params.query) { scrollEl = $el.find('[data-js-faq-form]'); }
        else if (params.category) { scrollEl = $el.find('[data-js-faq-categories]'); }
        else { scrollEl = $el.find('[data-js-faq-result]'); }

        if (scrollEl.length) {
            scrollTarget = scrollEl.offset().top - 90;
        }

        // return a promise.
        return $('html, body').animate({
            scrollTop: scrollTarget
        });
    };

    /**
     * cretes the child modules of the
     * faq form.
     */
    const createChilds = function() {
        let $formEl = $el.find('[data-js-faq-form]');
        if ($formEl.length) {
            faqForm($formEl, self, app);
        }

        let $resultEl = $el.find('[data-js-faq-result]');
        if ($resultEl.length) {
            faqResult($resultEl, self, app);
        }

        let $ask = $el.find('[data-js-faq-ask]');
        if ($ask.length) {
            askQuestion($ask[0], self, app);
        }
    };

    /**
     *
     */
    const buildParamUrl = function(pathname, paramObj) {
        const paramString = $.param(paramObj);
        return paramString ? `${pathname}?${paramString}` : pathname;
    };

    const normalizeLocationUrl = function(location) {
        const search = (location.search || '').replace(/^\?/, '');
        return search ? `${location.pathname}?${search}` : location.pathname;
    };

    const parseParams = function(location) {
        paramSplitter.lastIndex = 0;
        let search = location.search;
        let changedKeys = [];
        let keysToDelete = Object.keys(params);
        let match;
        while (match = paramSplitter.exec(search)) {
            let key = match[1];
            let value = decodeURIComponent(match[2].replace(/\+/g, ' '));

            // value has changed? register it.
            if (params[key] !== value) {
                changedKeys.push(key);
                params[key] = value;
            }

            // any keys in params that previously existed
            // but are removed now?
            let existingIndex = keysToDelete.indexOf(key);
            if (existingIndex !== -1) {
                keysToDelete.splice(existingIndex, 1);
            }
        }

        // remove the keys that was missing
        // in the url.
        keysToDelete.forEach((key) => {
            delete params[key];
            changedKeys.push(key);
        });

        // nothing changed, just return
        if (!changedKeys.length) { return; }

        // fire events that the params has changed.
        // one for each changed parameter...
        let changedParams = {};
        changedKeys.forEach((key) => {
            events.trigger(`param:${key}`, params[key]);
            changedParams[key] = params[key];
        });

        //... and one for all changed.
        events.trigger('param', changedParams);
    };

    /**
     * takes an object and updates the current history
     * with the changes passed.
     *
     * Note: if you want to completely remove a parameter from the history
     * send in `undefined` as value to its key.
     */
    const setParams = function(obj, options) {
        let clone = assign({}, params);
        var keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (params.hasOwnProperty(key) && typeof(obj[key]) === 'undefined') {
                delete clone[key];
                continue;
            }

            if (obj[key]) {
                clone[key] = obj[key];
            }
        }

        const url = buildParamUrl(history.location.pathname, clone);
        if (url === normalizeLocationUrl(history.location)) { return; }

        if (options && options.replace) {
            history.replace(url);
        }
        else { history.push(url); }
    };

    /**
     *
     */
    const getParams = function(name) {
        if (name) { return params[name]; }
        return params;
    };

    /**
     *
     */
    const setUrl = function(url) {
        let paramString = $.param(params)
        let hasQuery = url.match(/\?/);
        history.push(url + `${hasQuery ? '&': '?'}${paramString}`);
    };

    // expose the public functions
    // and mixin the eventEmitter
    const self = assign({
            setParams,
            getParams,
            setUrl,
            baseUrl,
            tmplCategory,
            tmplPrivateContact,
            tmplCompanyContact,
            tmplAnswer,
            tmplFeedback,
            tmplQuestion,
            on: events.on,
            off: events.off,
            trigger: events.trigger
        }
    );

    init();
    return self;
}

export default faq;
